import React from 'react';
import { SmartphoneIcon } from 'lucide-react';
const CTASection = () => {
  return <section id="download" className="py-16 md:py-24 bg-gradient-to-br from-[#E87B5C] to-[#D16A4A]" data-id="element-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-25">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 md:gap-16" data-id="element-26">
          <div className="md:w-1/2" data-id="element-27">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white" data-id="element-28">
              Transform Your Communication Today
            </h2>
            <p className="text-xl text-white/95 mb-8 max-w-lg" data-id="element-29">
              Download Emigo for{' '}
              <strong data-id="element-30">
                <em data-id="element-31">Free</em>
              </strong>
              . No credit card required and no personal information needed: we
              don't ask for your name, age, location, or anything else. Just
              onboard Emigo and start typing.
            </p>
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4" data-id="element-32">
              <a href="#" className="inline-block hover:opacity-90 transition-opacity" data-id="element-33">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/55BSmF1FDX8kQyzwZAZdd8/download-on-the-app-store.svg" alt="Download on the App Store" className="h-14" data-id="element-34" />
              </a>
              <div className="flex items-center justify-center bg-white/90 text-gray-700 px-6 py-3 rounded-lg cursor-not-allowed shadow-sm" data-id="element-35">
                <SmartphoneIcon className="mr-2 h-6 w-6" data-id="element-36" />
                <div data-id="element-37">
                  <div className="text-xs" data-id="element-38">Coming Soon</div>
                  <div className="text-lg font-semibold" data-id="element-39">Google Play</div>
                </div>
              </div>
            </div>
          </div>
          <div className="md:w-1/2 relative" data-id="element-40">
            <div className="relative max-w-xl mx-auto p-8 rounded-3xl bg-white border border-white/20 backdrop-blur-sm shadow-xl" data-id="element-41">
              <blockquote className="relative" data-id="element-42">
                <p className="text-2xl font-medium text-[#E87B5C] leading-relaxed mb-4" data-id="element-43">
                  "A single message can break a bond or build one. Emigo turns
                  impulse into reflection, helping you break the cycle and
                  choose connection, one conversation at a time."
                </p>
                <div className="h-px w-12 bg-[#E87B5C]/30 my-6" data-id="element-44"></div>
                <p className="text-[#E87B5C] text-lg" data-id="element-45">The Emigo Philosophy</p>
              </blockquote>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default CTASection;